/**
 * UndoRedoButtons Component
 * Undo and Redo buttons with disabled states
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Undo2, Redo2 } from 'lucide-react';

export const UndoRedoButtons = ({
  canUndo,
  canRedo,
  undo,
  redo,
}) => {
  return (
    <div className="hidden md:flex items-center gap-1 mr-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={undo}
        disabled={!canUndo}
        className={`p-2 ${canUndo ? 'text-zinc-400 hover:text-white' : 'text-zinc-600 cursor-not-allowed'}`}
        data-testid="undo-btn"
        title="Undo (Ctrl+Z)"
      >
        <Undo2 className="w-4 h-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={redo}
        disabled={!canRedo}
        className={`p-2 ${canRedo ? 'text-zinc-400 hover:text-white' : 'text-zinc-600 cursor-not-allowed'}`}
        data-testid="redo-btn"
        title="Redo (Ctrl+Shift+Z)"
      >
        <Redo2 className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default UndoRedoButtons;
